import React, { useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { FullHeaderLeftSideFullPanelLayout } from 'layouts/fullHeader.LeftSideFullPanel.layout';
import { APP } from 'app/AppRoutes';
import AuthorisationForm from './components/AuthorisationForm';
import ListView from './components/ListView';
import {
  getAuthorisationStart,
  getAuthorisationTypesStart,
  clearAllAuthorisations
} from 'redux/authorisation/actions';
import { useDispatch } from 'react-redux';
import { useComponentMount } from 'utilities/hooks.util';

const PremiumFeatures: React.FC<any> = ({ advancedOptions }) => {
  const [isFormOpen, setIsFormOpen] = useState<boolean>(false);
  const [formType, setFormType] = useState<
    'add' | 'edit' | 'add-order' | undefined
  >();
  const [selectedItem, setSelectedItem] = useState<number>(0);
  const dispatch = useDispatch();
  const [refreshListCounter, setRefreshListCounter] = useState<number>(0);

  const handleAddAuthorisation = () => {
    setIsFormOpen(true);
    setFormType('add');
  };
  const handleEditAuthorisation = (id: number) => {
    dispatch(getAuthorisationStart(id));
    setIsFormOpen(true);
    setSelectedItem(id);
    setFormType('edit');
  };
  const handleAddOrder = (authorisationId: number) => {
    handleEditAuthorisation(authorisationId);
    setFormType('add-order');
  };
  const refreshList = useCallback(() => {
    setRefreshListCounter(refreshListCounter + 1);
  }, [refreshListCounter]);

  useComponentMount(() => {
    dispatch(getAuthorisationTypesStart());
    return () => {
      dispatch(clearAllAuthorisations());
    };
  });

  return (
    <div
      id="premium-features"
      data-testid="premiumFeatures"
      className="premium-features"
    >
      <FullHeaderLeftSideFullPanelLayout
        pageHeading="Manage access to premium features"
        pageDescription="Select an item to authorise, revoke or modify access, or create a new authorisation"
        enableHeaderGlobalBar={true}
      >
        <ListView
          onAddAuthorisation={handleAddAuthorisation}
          onAddOrder={handleAddOrder}
          onEditAuthorisation={handleEditAuthorisation}
          refreshCounter={refreshListCounter}
        />
        {isFormOpen &&
          ReactDOM.createPortal(
            <AuthorisationForm
              advancedOptions={advancedOptions}
              formType={formType}
              authorisationId={selectedItem}
              onClose={() => {
                refreshList();
                setIsFormOpen(false);
              }}
              setFormType={setFormType}
            />,
            document.querySelector(`#${APP}`) || document.body
          )}
      </FullHeaderLeftSideFullPanelLayout>
    </div>
  );
};

export default PremiumFeatures;
